import Landing from './landing';
import { library } from "@fortawesome/fontawesome-svg-core";
import { 
 faGithubSquare,
 faLinkedin
} from "@fortawesome/free-brands-svg-icons";

import {
  faPaperPlane,
  faAngleDoubleUp
}
 from '@fortawesome/free-solid-svg-icons'

library.add(faGithubSquare, faLinkedin, faAngleDoubleUp, faPaperPlane);

function App() {
  return (
    <div className="App">
          <Landing />
    </div>
  );
}

export default App;
